<template>
  <div
    v-on-viewport="{
      handler: 'paginate',
    }"
  >
    <div class="paginate" style="height: 1px; width: 1px;"></div>
  </div>
</template>

<script>
export default {
  props: {
    itemsPerPage: {
      type: Number,
      default: 10,
    },
  },

  data() {
    return {
      page: 1,
    };
  },

  methods: {
    paginate() {
      this.page++;
      const { page, itemsPerPage } = this;
      this.$emit('paginate', { page, itemsPerPage });
    },
  },
};
</script>
